export default {
  name: 'Warehouse',
  id: 'Warehouse',
  data: [
    {
      title: 'The last few employees are heading out for the day.',
      icon1: '/static/svgs/commercial/warehouse.svg',
      answers: [
        'Disconnect all electrical equipment and appliances. Raise elevators (if applicable) from the bottom floor.'
      ],
      correctAnswerIndex: 0,
      position: {
        x: 0.4,
        y: 0.4,
        z: 1.35
      },
      completed: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/questionsData/commercial/firstFloor/Warehouse.js